import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './MemberTable.css';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import { Avatar, Box, Sheet, Table } from '@mui/joy';

const MemberTable = ({ members, display, search }) => {
    const [displayMembers, setDisplayMembers] = useState(members);

    useEffect(() => {
        setDisplayMembers(members);

        if (search?.length > 0) {
            const displayMem = members.filter((member) => {
                return (
                    member.fullName
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                    member.state.toLowerCase().includes(search.toLowerCase())
                );
            });

            setDisplayMembers(displayMem);
        }
    }, [display, search, members]);

    const goToWebsite = (member) => {
        window.open(member?.website, '_blank');
    };
    return (
        <Sheet className="rep-table" sx={{ maxHeight: 400, overflow: 'auto' }}>
            <Table
                stickyHeader
                aria-label="table"
                size="lg"
                sx={{ mx: 'auto', overflow: 'auto' }}
            >
                <thead>
                    <tr>
                        <th>Full Name</th>
                        <th>Party</th>
                        <th>State</th>
                        <th>Website Link</th>
                    </tr>
                </thead>
                <tbody>
                    {displayMembers
                        ? displayMembers.map((member, index) => (
                              <tr key={index}>
                                  <td>
                                      <Box
                                          sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 1.5,
                                          }}
                                      >
                                          <Avatar src={member.imageUrl} />
                                          <Typography noWrap level="title-md">
                                              {member.fullName}
                                          </Typography>
                                      </Box>
                                  </td>
                                  <td>
                                      <Typography noWrap level="body-md">
                                          {member.party}
                                      </Typography>
                                  </td>
                                  <td>
                                      <Typography noWrap level="body-md">
                                          {member.state}
                                      </Typography>
                                  </td>
                                  <td>
                                      <Button
                                          sx={{ width: '100%' }}
                                          variant="outlined"
                                          onClick={() => goToWebsite(member)}
                                      >
                                          Visit {member.firstName}'s website
                                      </Button>
                                  </td>
                              </tr>
                          ))
                        : null}
                </tbody>
            </Table>
        </Sheet>
    );
};

// Prop types for our Component
MemberTable.propTypes = {
    members: PropTypes.array.isRequired,
};

// Default Props for our Component
MemberTable.defaultProps = {};

export default MemberTable;
